import React from 'react';
import { FormattedMessage } from 'react-intl';
import SharedTable from 'shared/ui/Table';
import { TableWrapper, TabWrapper, Tab } from './styled';
import ActionBar from './components/ActionBar';
import accessTokensSchema from './schema';
import { useDispatch, useSelector } from 'react-redux';
import { selectActionToConfirm, selectIsFetching, selectShowActionModal, selectTab, selectUserTokens } from 'store/Settings/accessTokens/selectors';
import ActionModal from './components/ActionModal';
import { setOrderByUserTokens, setSelectedTab } from 'store/Settings/accessTokens/actions';

const Table = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector(selectTab);
  const tokens = useSelector(selectUserTokens);
  const isFetching = useSelector(selectIsFetching);
  const showActionModal = useSelector(selectShowActionModal);
  const actionToConfirm = useSelector(selectActionToConfirm);

  const handleTabClick = (tabName) => dispatch(setSelectedTab(tabName));

  const fetchData = (sorted) => !isFetching && dispatch(setOrderByUserTokens(sorted));

  const getThProps = (column) => {
    let border = '1px dashed #b7b7b7';

    if (column.id === 'actions') border = 'none';
    return {
      style: {
        borderRight: border
      }
    };
  };

  let noDataText = '';
  if (!isFetching) noDataText = <FormattedMessage id={ `preferences.accessTokens.${selectedTab}.empty` } />;

  return (
    <TableWrapper>
      <TabWrapper>
        <Tab active={ selectedTab === 'active' } onClick={ () => handleTabClick('active') }>Active</Tab>
        <Tab active={ selectedTab === 'inactive' } onClick={ () => handleTabClick('inactive') }>Inactive</Tab>
      </TabWrapper>
      <ActionBar tab={ selectedTab } />
      <SharedTable
        schema={ accessTokensSchema }
        context={ { tab: selectedTab, isFetching } }
        data={ tokens }
        isLoading={ isFetching }
        onFetch={ fetchData }
        style={ { height: '80%', boxShadow: '-8px 14px 20px 0px rgba(0, 0, 0, 0.03)' } }
        getHeaderProps={ (column) => getThProps(column) }
        noDataText={ noDataText }
      />
      { showActionModal && <ActionModal action={ actionToConfirm } /> }
    </TableWrapper>
  );
};

export default Table;
